module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "message-box animated"
  }, [_c('article', {
    class: ['message', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('div', {
    staticClass: "message-header"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    class: ['fa', ("fa-" + _vm.icon)]
  })]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a93a462"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-message/src/Message.vue
// module id = 424
// module chunks = 40